<template>
    <div class="newsPage">
<!--      <div class="product-img">-->
<!--        <img src="../../images/news.jpg">-->
<!--      </div>-->
      <banner :bannerType="news"></banner>
      <div class="newsPage-Content">
        <div class="newPubilc">最新发布</div>
        <div class="newsPage-content-list">
          <div class="newsPage-content-item" v-for="(item,i) in newsList" @click="toNewsDetail(item.id)">
              <div class="newsPage-content-item-left">
                <img src="../../images/news_timeline.jpg">
                <div>{{item.createTimeDeail}}</div>
              </div>
            <div class="newsPage-content-item-middle">
              <img :src="application.imageHost+item.logoPath">
            </div>
            <div class="newsPage-content-item-right">
              <div class="news-item-content">
                <div class="news-title">{{item.name}}</div>
                <div class="new-time">{{item.author}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.createTime}}</div>
                <div class="news-content">{{item.des}}</div>
              </div>
            </div>
          </div>



        </div>
      </div>

      <pagesBottom
        :page-index="currentPage"
        :total="count"
        :page-size="pageSize"
        @change="pageChange">
      </pagesBottom>
    </div>
</template>

<style src="./newsPage.css" scoped></style>

<script>
    import mixins from '../../common/mixin';
    import application from '../../common/application';
    import pagesBottom from "../../components/pagesBottom/pagesBottom";
    import banner from "../../components/banner/banner";
    export default {
        name: "newsPage",
        components:{
            pagesBottom,
            banner
        },
        mixins:[mixins],
        data () {
            return {
                pageSize : 5 , //每页显示20条数据
                currentPage : 1, //当前页码
                count : 0, //总记录数
                items : [],
                application:application,
                newsList:[],
                news:'news'
            }
        },
        mounted(){
           this.handleNewsList()
        },

        methods:{

            pageChange(page){
                this.currentPage = page
                this.handleNewsList()
            },
            //跳转到新闻详情
            toNewsDetail(){
                this.$router.push({
                    path:'/newsDetail/1'
                })
            },
            // 获取新闻列表
            handleNewsList(){
                this.request({
                    url: '/web/news/list',
                    data:{
                        "pageIndex": this.currentPage,
                        "pageSize": this.pageSize,
                        // "type": "string",
                        // "userId": 0

                    },
                    success: (response) => {
                        this.count=response.data.total;
                        this.newsList=response.data.records;
                        for(var i=0;i<this.newsList.length;i++){
                            this.newsList[i].createTime=this.formatDate(new Date(parseFloat(this.newsList[i].createTime)),'yyyy-MM-dd hh:mm')
                            this.newsList[i].createTimeDeail=this.newsList[i].createTime.substring(0,10)


                        }

                        console.log(response.data)

                    },
                    error: (response) => {
                        this.$Message.error(response.message);
                    },
                    complete: () => {
                    }
                });
            },
            //跳转到新闻详情
            toNewsDetail(id){
                this.$router.push({
                    path:'/newsDetail/'+id
                })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/newsPage/newsPage.vue